export const READINESS_TRACKING_PAGE_CONST = {
    localStorage: {
        sidebarCollapsedKey: 'readinessTrackingSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
